/*
Eingeladener Anbieter wird nach dem Login automatisch
auf seine Ausschreibung geleitet, statt auf der Home-Seite zu landen
 */
import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {map, Observable, of} from 'rxjs';
import {AusschreibungService} from '../service/ausschreibung.service';

// Modul-State statt Service-Feld: soll genau einmal pro Bundle-Ladung feuern,
// sonst würde jede spätere Navigation wieder zur Ausschreibung zurückspringen.
let redirected = false;

export const submissionRedirectGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const ausschreibungService = inject(AusschreibungService);
  const submissionId = ausschreibungService.getSubmissionFromParam();

  if (redirected || !submissionId) {
    return of(true);
  }

  const router = inject(Router);
  return ausschreibungService.isSignedIn().pipe(
    map(signedIn => {
      redirected = true;
      return signedIn ? router.createUrlTree(['/ausschreibung', submissionId]) : true;
    }),
  );
};
